var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailEditorLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.168 11.167v1.666h11.667v-1.666H.168zm3.75-3.5h4.167l.75 1.833h1.75L6.626.333h-1.25L1.418 9.5h1.75l.75-1.833zm2.083-5.684L7.56 6.167H4.443l1.558-4.184z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuMTY3OTY5IDExLjE2NjZWMTIuODMzM0gxMS44MzQ2VjExLjE2NjZIMC4xNjc5NjlaTTMuOTE3OTcgNy42NjY1OUg4LjA4NDY0TDguODM0NjQgOS40OTk5MkgxMC41ODQ2TDYuNjI2MyAwLjMzMzI1Mkg1LjM3NjNMMS40MTc5NyA5LjQ5OTkySDMuMTY3OTdMMy45MTc5NyA3LjY2NjU5Wk02LjAwMTMgMS45ODMyNUw3LjU1OTY0IDYuMTY2NThINC40NDI5N0w2LjAwMTMgMS45ODMyNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgEmailEditorLinkIcon as ReactComponent };